import { IUser } from '@sdk/contracts';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useProfileModal, useUserDetail } from '@/hooks';
import { useProfile } from '@/store';

interface UseStudentProfilePreviewModalStateResult {
  isOpen: boolean;
  isLoading: boolean;
  selectedUser?: IUser;
  canEdit: boolean;
  handleClose: () => void;
}

export const useStudentProfilePreviewModalState = (): UseStudentProfilePreviewModalStateResult => {
  const [searchParams] = useSearchParams();
  const { closeProfile } = useProfileModal();
  const { profile: me } = useProfile();

  const profileId = searchParams.get('profileId') || undefined;

  const isMe = !!me && !!profileId && me._id === profileId;

  const { user, isLoading } = useUserDetail(!isMe ? profileId : undefined);

  const selectedUser = useMemo<IUser | undefined>(() => {
    if (!profileId) return undefined;
    if (isMe) return me;
    return user;
  }, [isMe, me, user, profileId]);

  const handleClose = () => closeProfile();

  return {
    isOpen: !!profileId,
    isLoading,
    selectedUser,
    canEdit: isMe,
    handleClose
  };
};
